<template>
    <v-row>
        <v-col>
            <h1>drawer</h1>
            <v-color-picker v-model="colorPick" hide-inputs></v-color-picker>
        </v-col>
        <v-col>
            <h1>background - {{ isDarkMode ? "DarkMode" : "LightMode" }} - {{ colorPickBG }}</h1>
            <v-color-picker v-model="colorPickBG" hide-inputs></v-color-picker>
        </v-col>

    </v-row>

</template>

<script setup lang="ts">
import { ref, watch,computed } from 'vue';
import { useTheme } from 'vuetify';
const theme = useTheme();
import { COLORS_IN_HTML, changeColor } from '@/constants/colors';

const isDarkMode    = computed(() => theme.global.name.value === 'darkCustom')
const colorPick     = ref(COLORS_IN_HTML.value.drawer);
const colorPickBG   = ref(theme.global.current.value.colors.background);

watch(colorPick,(color:string) => {
    // COLORS.COLORS_IN_HTML.value.drawer = color;
    changeColor(color);
})
watch(colorPickBG,(color:string) => {
    if(isDarkMode.value){
      theme.themes.value.darkCustom.colors.background = color??''
    }else{
        theme.themes.value.lightCustom.colors.background = color??''
    }
  
})

</script>

<style scoped>

</style>